import { render, staticRenderFns } from "./MapaComponent.vue?vue&type=template&id=25a31978&scoped=true&"
import script from "./MapaComponent.vue?vue&type=script&lang=js&"
export * from "./MapaComponent.vue?vue&type=script&lang=js&"
import style0 from "./MapaComponent.vue?vue&type=style&index=0&id=25a31978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a31978",
  null
  
)

export default component.exports